import { useApi, apiPost } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingBlock, ErrorState } from "@/components/common/StateViews";
import { SeverityChip } from "@/components/common/SeverityChip";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { toast } from "sonner";
import { FileCheck2, Download } from "lucide-react";

export default function Evidence() {
  const { data: frameworks = [], isLoading, error } = useApi("evidence", "/evidence/frameworks");
  const gen = async (fw) => { const r = await apiPost("/evidence/pack", { framework: fw }); toast.success(`Evidence pack generated for ${fw}: ${r.artifacts.length} artifacts`); };
  if (error) return <ErrorState />;

  return (
    <div>
      <PageHeader eyebrow="Navitra Lens · Evidence Room" title="Evidence" subtitle="Controls mapped to the frameworks that matter. Generate an audit evidence pack in under a day.">
        <Button size="sm" onClick={() => gen("All frameworks")} data-testid="gen-all"><Download className="h-4 w-4 mr-1.5" />Generate full pack</Button>
      </PageHeader>
      {isLoading ? <LoadingBlock /> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {frameworks.map((f) => {
            const pct = Math.round((f.controls_mapped / f.controls_total) * 100);
            return (
              <Card key={f.framework} data-testid={`fw-${f.framework}`}>
                <CardHeader className="pb-2"><div className="flex items-start justify-between"><CardTitle className="text-base flex items-center gap-2"><FileCheck2 className="h-4 w-4 text-navy" />{f.framework}</CardTitle><SeverityChip level={f.status} /></div></CardHeader>
                <CardContent className="space-y-3">
                  <div className="flex justify-between text-sm"><span className="text-muted-foreground">Controls mapped</span><span className="mono">{f.controls_mapped}/{f.controls_total}</span></div>
                  <Progress value={pct} className="[&>div]:bg-gold" />
                  <Button variant="outline" size="sm" className="w-full" onClick={() => gen(f.framework)} data-testid={`gen-${f.framework}`}>Generate pack</Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
